import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

// eslint-disable-next-line react/prop-types
const IconNewPreparingOrder = ({
  className,
  height,
  width,
  fill
}: IconInterface) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox='0 0 101 101'
      fill={fill || 'none'}
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='0.936279'
        y='1'
        width='99'
        height='99'
        rx='15.5'
        fill='white'
        stroke='#D6D6D6'
      />
      <g clipPath='url(#clip0_1340:7310)'>
        <path
          d='M82.7035 48.4593C82.7035 51.8805 79.9301 54.6539 76.5089 54.6539C73.0876 54.6539 70.3142 51.8805 70.3142 48.4593C70.3142 45.038 73.0876 42.2646 76.5089 42.2646C79.9301 42.2646 82.7035 45.038 82.7035 48.4593Z'
          fill='url(#paint0_linear_1340:7310)'
        />
        <path
          d='M35.8876 24.093C35.8876 32.6192 28.9757 39.531 20.4495 39.531C11.9233 39.531 5.01147 32.6192 5.01147 24.093C5.01147 15.5668 11.9233 8.65493 20.4495 8.65493C28.9757 8.65493 35.8876 15.5668 35.8876 24.093Z'
          fill='url(#paint1_linear_1340:7310)'
        />
        <path
          d='M100.176 14.0554C100.176 26.3122 90.2395 36.2483 77.9827 36.2483C65.7259 36.2483 55.7898 26.3122 55.7898 14.0554C55.7898 1.79855 65.7259 -8.13756 77.9827 -8.13756C90.2395 -8.13756 100.176 1.79855 100.176 14.0554Z'
          fill='url(#paint2_linear_1340:7310)'
        />
        <path
          d='M69.4945 9.63629C69.4945 21.8931 59.5584 31.8292 47.3016 31.8292C35.0448 31.8292 25.1086 21.8931 25.1086 9.63629C25.1086 -2.62053 35.0448 -12.5566 47.3016 -12.5566C59.5584 -12.5566 69.4945 -2.62053 69.4945 9.63629Z'
          fill='url(#paint3_linear_1340:7310)'
        />
        <path
          d='M73.7873 38.5497C73.7873 50.8065 63.8512 60.7426 51.5944 60.7426C39.3376 60.7426 29.4015 50.8065 29.4015 38.5497C29.4015 26.2929 39.3376 16.3568 51.5944 16.3568C63.8512 16.3568 73.7873 26.2929 73.7873 38.5497Z'
          fill='url(#paint4_linear_1340:7310)'
        />
        <path
          d='M87.1855 37.6372C87.1855 42.7197 83.0653 46.84 77.9827 46.84C72.9002 46.84 68.7799 42.7197 68.7799 37.6372C68.7799 32.5546 72.9002 28.4344 77.9827 28.4344C83.0653 28.4344 87.1855 32.5546 87.1855 37.6372Z'
          fill='url(#paint5_linear_1340:7310)'
        />
        <path
          d='M39.5236 43.8541C39.5236 49.8187 34.6884 54.6539 28.7238 54.6539C22.7593 54.6539 17.924 49.8187 17.924 43.8541C17.924 37.8896 22.7593 33.0544 28.7238 33.0544C34.6884 33.0544 39.5236 37.8896 39.5236 43.8541Z'
          fill='url(#paint6_linear_1340:7310)'
        />
      </g>
      <path
        d='M17.3937 46.309H83.4641V70.8494C83.4641 78.1473 77.548 84.0635 70.2501 84.0635H30.6078C23.3099 84.0635 17.3937 78.1473 17.3937 70.8494V46.309Z'
        fill='url(#paint7_linear_1340:7310)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.4082 54.5102C18.891 54.5102 20.0931 53.3081 20.0931 51.8254C20.0931 50.3426 18.891 49.1405 17.4082 49.1405C15.9255 49.1405 14.7234 50.3426 14.7234 51.8254C14.7234 53.3081 15.9255 54.5102 17.4082 54.5102ZM17.4082 57.3418C20.4549 57.3418 22.9247 54.872 22.9247 51.8254C22.9247 48.7787 20.4549 46.309 17.4082 46.309C14.3616 46.309 11.8918 48.7787 11.8918 51.8254C11.8918 54.872 14.3616 57.3418 17.4082 57.3418Z'
        fill='url(#paint8_linear_1340:7310)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M83.4639 54.5102C84.9467 54.5102 86.1487 53.3081 86.1487 51.8254C86.1487 50.3426 84.9467 49.1405 83.4639 49.1405C81.9811 49.1405 80.7791 50.3426 80.7791 51.8254C80.7791 53.3081 81.9811 54.5102 83.4639 54.5102ZM83.4639 57.3418C86.5106 57.3418 88.9803 54.872 88.9803 51.8254C88.9803 48.7787 86.5108 46.309 83.4641 46.309C80.4175 46.309 77.9475 48.7787 77.9475 51.8254C77.9475 54.872 80.4173 57.3418 83.4639 57.3418Z'
        fill='url(#paint9_linear_1340:7310)'
      />
      <path
        d='M14.1102 77.2661L17.5118 77.3821C22.3074 77.5457 26.0624 81.5658 25.8989 86.3615L25.7829 89.7631L22.3813 89.6471C17.5857 89.4835 13.8306 85.4633 13.9942 80.6677L14.1102 77.2661Z'
        fill='url(#paint10_linear_1340:7310)'
      />
      <path
        d='M28.8973 80.4327L30.7326 81.2487C33.32 82.3991 34.4849 85.4293 33.3345 88.0167L32.5185 89.852L30.6832 89.036C28.0957 87.8855 26.9308 84.8554 28.0813 82.268L28.8973 80.4327Z'
        fill='url(#paint11_linear_1340:7310)'
      />
      <path
        d='M71.984 75.1321L69.4741 77.485C65.9357 80.8022 65.9357 86.1803 69.4741 89.4975L74.4938 89.4975C78.0322 86.1803 78.0322 80.8022 74.4938 77.485L71.984 75.1321Z'
        fill='url(#paint12_linear_1340:7310)'
      />
      <path
        d='M87.8832 76.4862L84.0627 76.311C78.6765 76.064 74.1099 80.2302 73.8629 85.6164L73.6877 89.437L77.5082 89.6122C82.8944 89.8591 87.4611 85.693 87.7081 80.3067L87.8832 76.4862Z'
        fill='url(#paint13_linear_1340:7310)'
      />
      <path
        d='M59.8965 83.2158L61.7796 83.1158C64.4344 82.9748 66.7008 85.0127 66.8418 87.6676L66.9418 89.5507L65.0587 89.6507C62.4038 89.7916 60.1374 87.7537 59.9964 85.0989L59.8965 83.2158Z'
        fill='url(#paint14_linear_1340:7310)'
      />
      <path
        d='M17.2917 36.3345C18.2396 29.3455 24.6737 24.4483 31.6627 25.3962L72.5243 30.938C79.5133 31.8859 84.4105 38.32 83.4626 45.3089L17.2917 36.3345Z'
        fill='#072D52'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M53.0815 31.3242C55.2416 31.6001 56.5452 30.2523 56.685 29.1585C56.8247 28.0647 55.9018 26.4325 53.7417 26.1565C51.5816 25.8805 50.278 27.2283 50.1382 28.3221C49.9985 29.4159 50.9214 31.0482 53.0815 31.3242ZM52.6629 34.6005C56.2802 35.0626 59.5478 32.8136 59.9613 29.5771C60.3748 26.3406 57.7776 23.3423 54.1603 22.8801C50.543 22.418 47.2754 24.667 46.8619 27.9035C46.4484 31.14 49.0456 34.1383 52.6629 34.6005Z'
        fill='#072D52'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1340:7310'
          x1='52.5936'
          y1='2.55293'
          x2='52.5936'
          y2='52.8042'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F1F1F1' stopOpacity='0' />
          <stop offset='0.38191' stopColor='#F1F1F1' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1340:7310'
          x1='52.5936'
          y1='2.55293'
          x2='52.5936'
          y2='52.8042'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F1F1F1' stopOpacity='0' />
          <stop offset='0.38191' stopColor='#F1F1F1' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_1340:7310'
          x1='52.5936'
          y1='2.55293'
          x2='52.5936'
          y2='52.8042'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F1F1F1' stopOpacity='0' />
          <stop offset='0.38191' stopColor='#F1F1F1' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_1340:7310'
          x1='52.5936'
          y1='2.55293'
          x2='52.5936'
          y2='52.8042'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F1F1F1' stopOpacity='0' />
          <stop offset='0.38191' stopColor='#F1F1F1' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_1340:7310'
          x1='52.5936'
          y1='2.55293'
          x2='52.5936'
          y2='52.8042'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F1F1F1' stopOpacity='0' />
          <stop offset='0.38191' stopColor='#F1F1F1' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_1340:7310'
          x1='52.5936'
          y1='2.55293'
          x2='52.5936'
          y2='52.8042'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F1F1F1' stopOpacity='0' />
          <stop offset='0.38191' stopColor='#F1F1F1' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_1340:7310'
          x1='52.5936'
          y1='2.55293'
          x2='52.5936'
          y2='52.8042'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F1F1F1' stopOpacity='0' />
          <stop offset='0.38191' stopColor='#F1F1F1' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_1340:7310'
          x1='34.4879'
          y1='49.7148'
          x2='60.2162'
          y2='109.07'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0A3040' />
          <stop offset='0.222055' stopColor='#062B58' />
          <stop offset='0.875044' stopColor='#7F50E3' />
        </linearGradient>
        <linearGradient
          id='paint8_linear_1340:7310'
          x1='34.4879'
          y1='49.7148'
          x2='60.2162'
          y2='109.07'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0A3040' />
          <stop offset='0.222055' stopColor='#062B58' />
          <stop offset='0.875044' stopColor='#7F50E3' />
        </linearGradient>
        <linearGradient
          id='paint9_linear_1340:7310'
          x1='34.4879'
          y1='49.7148'
          x2='60.2162'
          y2='109.07'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0A3040' />
          <stop offset='0.222055' stopColor='#062B58' />
          <stop offset='0.875044' stopColor='#7F50E3' />
        </linearGradient>
        <linearGradient
          id='paint10_linear_1340:7310'
          x1='50.9361'
          y1='75.1321'
          x2='50.9361'
          y2='89.852'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F5A623' />
          <stop offset='1' stopColor='#F5A623' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint11_linear_1340:7310'
          x1='50.9361'
          y1='75.1321'
          x2='50.9361'
          y2='89.852'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F5A623' />
          <stop offset='1' stopColor='#F5A623' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint12_linear_1340:7310'
          x1='50.9361'
          y1='75.1321'
          x2='50.9361'
          y2='89.852'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F5A623' />
          <stop offset='1' stopColor='#F5A623' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint13_linear_1340:7310'
          x1='50.9361'
          y1='75.1321'
          x2='50.9361'
          y2='89.852'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F5A623' />
          <stop offset='1' stopColor='#F5A623' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint14_linear_1340:7310'
          x1='50.9361'
          y1='75.1321'
          x2='50.9361'
          y2='89.852'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F5A623' />
          <stop offset='1' stopColor='#F5A623' stopOpacity='0' />
        </linearGradient>
        <clipPath id='clip0_1340:7310'>
          <path
            d='M5.01147 1.44336H84.0115C92.848 1.44336 100.011 8.6068 100.011 17.4434V60.4434H5.01147V1.44336Z'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Icon(IconNewPreparingOrder)
